module.exports = __webpack_public_path__ + "assets/img/wen_tu02.7cb00154.jpg";